//
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import "./../App.css";
import { Routes } from "../constants";
import { AdminService } from "../services";
import { toast } from "react-toastify";
import { injectModels } from "../redux/injectModels";

const BuySubscription = (props) => {
  const history = useHistory();

  const [userDetails, setUserDetails] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [minimumAccepted, setMinimumAccepted] = useState(false);

  const userId = localStorage.getItem("user_id");
  const isValidToken = localStorage.getItem("accessToken");
  const isSubs = localStorage.getItem("Subscription_status");
  // const isTrial = localStorage.getItem("trial");

  const isSubscribed = isSubs == 1;

  useEffect(() => {
    if (!isValidToken) {
      history.push(Routes.LOGIN);
    } else {
      fetchUser();
    }
  }, []);

  const fetchUser = async () => {
    try {
      const res = await AdminService.getUserDetails(userId);
      setUserDetails(res || {});
    } catch (error) {
      console.error("User detail fetch failed", error);
      setUserDetails({});
    }
  };
  // const handleProceed = () => {
  //   if (!termsAccepted) {
  //     toast.dismiss();
  //     toast.error("Please accept Terms & Conditions");
  //     return;
  //   }

  //   history.push(Routes.STRIPE_CHECKOUT);
  // };
  const handleProceed = () => {
    if (!termsAccepted) {
      toast.dismiss();
      toast.error("Please accept Terms & Conditions");
      return;
    }

    if (!minimumAccepted) {
      toast.dismiss();
      toast.error("Please agree to subscribe for a minimum of 6 months");
      return;
    }

    history.push(Routes.STRIPE_CHECKOUT);
  };

  return (
    <section className="premium-checkout">
      <div className="container">
        <div className="row ju">
          <div className="col-md-12">
            <h2 className="uph2 mb-4">Subscription</h2>
          </div>

          <div className="col-xxl-7 col-xl-7 col-lg-7 col-md-10">
            {/* USER INFO */}
            <div className="heckout-right">
              <div className="payment-login payment-logut pb-3">
                <h5 className="pt-0">
                  <i className="fa-solid fa-check"></i> Signed in
                  <div className="email-showing">{userDetails.email}</div>
                </h5>

                <div className="logout-checkout">
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      props.auth.logout();
                      localStorage.clear();
                      history.push(Routes.LOGIN);
                    }}
                    className="dropdown-item"
                  >
                    <i className="fa-solid fa-arrow-right-from-bracket" />
                    <span>Logout</span>
                  </Link>
                </div>
              </div>
            </div>

            {/* ORDER SUMMARY */}
            <div className="order-summary">
              <h6>Order summary</h6>

              <div className="membership-plan-checkout">
                <p>Plan</p>
                <p>Gewardz Health</p>
              </div>

              <div className="membership-plan-checkout">
                <p>Duration</p>
                <p>
                  Until cancelled
                  <a
                    href="https://gewardzhealth.com/terms-of-service"
                    target="_blank"
                    rel="noreferrer"
                  >
                    *
                  </a>
                </p>
              </div>
            </div>

            {isSubscribed && userDetails?.payment && (
              <div className="order-summary mt-3">
                <h6>Payment details</h6>

                <div className="membership-plan-checkout">
                  <p>Amount Paid</p>
                  <p>{userDetails.payment.amount}</p>
                </div>

                <div className="membership-plan-checkout">
                  <p>Subscription Type</p>
                  <p className="text-capitalize">
                    {userDetails.payment.subscription_type}
                  </p>
                </div>

                <div className="membership-plan-checkout">
                  <p>Expiry Date</p>
                  <p>{userDetails.payment.expiry_at}</p>
                </div>
              </div>
            )}

            {/* {!(isSubs == 1) && (
              <div className="mt-3">
                <label className="terms-checkbox">
                  <input
                    type="checkbox"
                    checked={termsAccepted}
                    onChange={() => setTermsAccepted(!termsAccepted)}
                  />
                  I agree to the{" "}
                  <a
                    href="https://gewardzhealth.com/terms-of-service"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Terms & Conditions
                  </a>
                </label>
              </div>
            )} */}
            {!isSubscribed && (
              <>
                <div className="mt-3">
                  <label className="terms-checkbox">
                    <input
                      type="checkbox"
                      checked={termsAccepted}
                      onChange={() => setTermsAccepted(!termsAccepted)}
                    />
                    I agree to the{" "}
                    <a
                      href="https://gewardzhealth.com/terms-of-service"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Terms & Conditions
                    </a>
                  </label>
                </div>

                <div className="mt-2">
                  <label className="terms-checkbox">
                    <input
                      type="checkbox"
                      checked={minimumAccepted}
                      onChange={() => setMinimumAccepted(!minimumAccepted)}
                    />
                    I agree to subscribe for a minimum of 6 months
                  </label>
                </div>
              </>
            )}

            {/* CTA */}
            {isSubs == 1 ? (
              <a
                href="mailto:support@gewardz.com?subject=Subscription Cancellation Request"
                className="btn-bx-shadow w-100 mt-3 subs-cancel"
              >
                Please note that I wish to cancel my subscription
              </a>
            ) : (
              <>
                <button
                  className="org-big-btn btn-bx-shadow w-100 mt-3"
                  onClick={handleProceed}
                >
                  <span>Click here to Subscribe</span>
                </button>
                {/* <p className="minimum-note mt-2">*Minimum 6-month</p> */}
              </>
            )}

            {/* CONTACT INFO */}
            <div className="contact-assistance mt-4">
              <p>
                <>For Assistance:</>{" "}
                <a href="mailto:sara@gewardz.com">sara@gewardz.com</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default injectModels(["auth"])(BuySubscription);
